import { COMPANY_INFO } from '@repo/api-contracts';

/**
 * 사업자 정보 표시 줄 — 전자상거래법상 표시 사항. 값의 단일 원천은 `@repo/api-contracts` 의 `COMPANY_INFO` 다
 * (api 견적 발행 설정의 공급자 칸도 같은 값을 쓴다). 여기서는 화면 라벨과 연결 주소만 붙인다.
 * 사이트 푸터(widgets/site-footer)와 회사 소개(widgets/about-company)가 함께 쓴다.
 */

export interface CompanyFact {
  readonly label: string;
  readonly value: string;
  /** 누르면 연결되는 주소(메일·전화). */
  readonly href?: string;
}

export const COMPANY_FACTS: readonly CompanyFact[] = [
  { label: '상호', value: COMPANY_INFO.companyName },
  { label: '대표이사', value: COMPANY_INFO.representativeName },
  { label: '주소', value: COMPANY_INFO.address },
  { label: '사업자등록번호', value: COMPANY_INFO.businessRegistrationNumber },
  { label: '통신판매업신고번호', value: COMPANY_INFO.mailOrderSalesRegistrationNumber },
  { label: 'E-Mail', value: COMPANY_INFO.email, href: `mailto:${COMPANY_INFO.email}` },
  { label: '전화번호', value: COMPANY_INFO.phone, href: `tel:${COMPANY_INFO.phone}` },
  { label: '상담 운영시간', value: COMPANY_INFO.consultationHours },
  { label: '계좌번호', value: COMPANY_INFO.bankAccount },
];
